import { ExcalidrawElement } from '@excalidraw/excalidraw/types/element/types';
import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

export const useGameExcalidrawJSONUpload = () => {
  const { mutate: upload, error, isLoading, isSuccess } = useMutation(
    async ({
      fileId,
      elements,
    }: {
      fileId: string;
      elements: readonly ExcalidrawElement[];
    }) => {
      const data = await BackendService.instance.getUploadUrl(`game_files/${fileId}`);
      const url = data.data;
      const jsonString = JSON.stringify(elements);
      const blob = new Blob([jsonString], { type: 'application/json' });
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', blob.type);

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject(xhr.response);
            }
          }
        };
        xhr.onerror = function(response) {
          reject(response);
        };
        xhr.send(blob);
      });
      return Promise.resolve();
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    error: error,
  };
};
